// Transfer tab: internal list page (card) vs detail page (back + per-source UI)

import { useState } from 'react';
import { transferSources, getTransferSourceById, TRANSFER_SOURCE_KIND } from '../transferSources';
import { TransferSourceListItem } from './TransferSourceListItem';
import { TransferSourceDetailGumroad } from './TransferSourceDetailGumroad';
import './TransferSection.css';

function TransferSourceDetailBody({ source, transferAdminTestMode }) {
  switch (source.kind) {
    case TRANSFER_SOURCE_KIND.GUMROAD:
      return (
        <TransferSourceDetailGumroad
          source={source}
          transferAdminTestMode={transferAdminTestMode}
        />
      );
    default:
      return null;
  }
}

export function TransferSection({ user }) {
  const [selectedSourceId, setSelectedSourceId] = useState(null);
  const [transferAdminTestMode, setTransferAdminTestMode] = useState(false);
  const selectedSource = selectedSourceId ? getTransferSourceById(selectedSourceId) : null;
  const isAdmin = user?.role === 'admin';

  if (selectedSource) {
    return (
      <div className="transfer-section transfer-section--detail">
        <div className="transfer-detail-toolbar">
          <button
            type="button"
            className="transfer-detail-back"
            onClick={() => setSelectedSourceId(null)}
          >
            <i className="fa-solid fa-arrow-left" aria-hidden />
            <span>Back</span>
          </button>
          {isAdmin && (
            <button
              type="button"
              className={`transfer-admin-test-toggle ${transferAdminTestMode ? 'is-on' : ''}`}
              onClick={() => setTransferAdminTestMode((v) => !v)}
              title="In-memory only. When on, recipient checks show as warnings and do not block; transfer stays dry-run."
            >
              <i className="fa-solid fa-flask" aria-hidden />
              <span>Admin test {transferAdminTestMode ? 'ON' : 'OFF'}</span>
            </button>
          )}
        </div>
        {isAdmin && transferAdminTestMode && (
          <p className="transfer-detail-admin-hint">
            Admin test mode: recipient checks do not block the form. Transfer runs a server dry-run only (same checks as production; no entitlement changes).
          </p>
        )}
        <div className="transfer-detail-header">
          <h2 className="transfer-detail-title">
            {selectedSource.detailTitle ?? selectedSource.displayName}
          </h2>
        </div>
        <TransferSourceDetailBody
          source={selectedSource}
          transferAdminTestMode={transferAdminTestMode}
        />
      </div>
    );
  }

  return (
    <div className="transfer-section transfer-section--list">
      <div className="account-card">
        <div className="card-header">
          <h2 className="card-title">
            <i className="fa-solid fa-right-left" aria-hidden />
            Transfer
          </h2>
        </div>
        <div className="card-body">
          <div className="transfer-source-list">
            {transferSources.map((source) => (
              <TransferSourceListItem
                key={source.id}
                source={source}
                onSelect={(entry) => setSelectedSourceId(entry.id)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
